import {
  CertificationUpdateInput,
  UpdateCertificationMutation,
  UpdateCertificationMutationVariables,
} from '__generated__/graphql';
import { UPDATE_CERTIFICATION_MUTATION } from 'apollo/mutations/certification.mutations';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { isNil } from 'lodash';
import { useCallback } from 'react';

export const useUpdateCertification = () => {
  const client = useGraphQLClient();

  const updateCertification = useCallback(
    async (certification: CertificationUpdateInput) => {
      const result = await client.request<UpdateCertificationMutation, UpdateCertificationMutationVariables>({
        document: UPDATE_CERTIFICATION_MUTATION,
        variables: {
          certification,
        },
      });

      if (isNil(result.updateCertification)) {
        throw Error(`result was ${result.updateCertification}`);
      }

      return result.updateCertification;
    },
    [client]
  );

  return updateCertification;
};
